import { siteRoutes } from "@circle-react/lib/routes/site";

import { t } from "@/i18n-js/instance";

import { NavGroup } from "../NavGroup";
import { SubNavLinkItem } from "./SubNavLinkItem";
import type { Link } from "./types";

export const useSiteLinks = (): Link[] => [
  {
    label: t("settings_nav_v3.site.navigation"),
    path: siteRoutes.navigation(),
    exact: true,
  },
  {
    label: t("settings_nav_v3.site.seo"),
    path: siteRoutes.seo(),
    exact: true,
  },
  {
    label: t("settings_nav_v3.site.redirects"),
    path: siteRoutes.redirects(),
    exact: true,
  },
  {
    label: t("settings_nav_v3.site.defaults"),
    path: siteRoutes.index(),
    exact: true,
  },
  {
    label: t("settings_nav_v3.site.code_snippets"),
    path: siteRoutes.codeSnippets(),
    exact: true,
  },
];

export const SiteLinks = () => {
  const links = useSiteLinks();

  return (
    <NavGroup groupLinks={links}>
      <NavGroup.Content title={t("settings_nav_v3.site.label")}>
        {links.map(link => (
          <SubNavLinkItem
            key={link.path}
            label={link.label}
            to={link.path}
            isNewFeature={!!link.isNewFeature}
          />
        ))}
      </NavGroup.Content>
    </NavGroup>
  );
};
